import React from "react";
import { TrashIcon } from "@heroicons/react/24/outline";

type ImageItem = {
  imageSrc: string;
  imageUrl: string;
};

type Props = {
  imageList: ImageItem[];
  setImageList: React.Dispatch<React.SetStateAction<ImageItem[]>>;
};

const ImageDisplay = ({ imageList, setImageList }: Props) => {
  const handleImageRemove = (imageSrc: string) => {
    setImageList(imageList.filter((image) => image.imageSrc !== imageSrc));
  };

  return (
    <div className="flex flex-col gap-2 mb-2">
      <div className="block text-sm font-medium text-gray-600">Image</div>
      <div className="text-sm text-gray-500 border py-2 px-4 rounded-md">
        <div className="text-sm text-gray-500 pb-2">Paste Image here</div>
        <div className="grid grid-cols-3 gap-4">
          {imageList.map((image, index) => (
            <div
              key={index}
              className="flex items-center justify-center relative"
            >
              <img
                src={image.imageSrc}
                alt="Pasted"
                className="max-h-48 max-w-48 rounded-md"
              />
              <div
                onClick={() => handleImageRemove(image.imageSrc)}
                className="absolute top-[-10px] right-[-10px] cursor-pointer hover:bg-gray-100 rounded-full p-1"
              >
                <TrashIcon className="w-5 h-5 p-1 text-gray-500 bg-white rounded-full border border-gray-300" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageDisplay;
